/* eslint-disable import/no-anonymous-default-export */
import { FETCH_FUTURE_BID_ERROR, FETCH_FUTURE_BID_ERROR_ERROR } from '../types';

const initialState = {
  futureBotErrorData: [],
  success: false,
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FUTURE_BID_ERROR:
      return {
        ...state,
        futureBotErrorData: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_BID_ERROR_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };

    default:
      return state;
  }
}
